
import { Alert, AlertTitle, Box } from "@mui/material";
import { useTranslation } from "react-i18next";


import type { JSX } from "react";


export type NoDataProps = {
    title?: string | null,
    text: string | JSX.Element | null | undefined
    severity?: "error" | "info" | "success" | "warning"
}

export default function NoData({ 
    title,
    text,
    severity
}: NoDataProps) {

    const { t } = useTranslation();

    return (

        <Box>
            <Alert severity={severity ?? "info"}>
            <AlertTitle>{title ?? t('noData.title')}</AlertTitle>
            <Box data-testid='nodatatext'>
                {text}
            </Box>
            </Alert>
        </Box>
    );
}
